import { useEffect, useMemo } from "react";
import {
  NAV,
  useActiveSection,
  useParallax,
  useScrollReveal,
  Header,
  Hero,
  Product,
  Effects,
  EffectsInfringer,
  Cases,
  Pricing,
  Faq,
  Cta,
  Footer
} from "./landing/index.js";

export function App() {
  const sectionIds = useMemo(() => ["top", ...NAV.map((n) => n.id), "cta"], []);
  const active = useActiveSection(sectionIds);

  useScrollReveal();
  useParallax();

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") {
        const activeEl = document.activeElement;
        if (activeEl && typeof activeEl.blur === "function") activeEl.blur();
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  return (
    <div className="app">
      <a className="skipLink" href="#product">
        Перейти к содержимому
      </a>

      <Header activeId={active} />

      <main>
        <Hero />
        <Product />
        <Effects />
        <EffectsInfringer />
        <Cases />
        {/* <Pricing /> */}
        <Faq />
        <Cta />
      </main>

      <Footer />
    </div>
  );
}
